var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconPersonInShot = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.97183 20.0282V12.9859H2V20.0282C2 20.5602 2.18779 21.0297 2.56338 21.4366C2.97027 21.8122 3.43975 22 3.97183 22H11.0141V20.0282H3.97183Z",
    fill: "#878793"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0282 12.9859V20.0282H12.9859V22H20.0282C20.5602 22 21.0141 21.8122 21.3897 21.4366C21.7966 21.0297 22 20.5602 22 20.0282V12.9859H20.0282Z",
    fill: "#878793"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.3897 2.61033C21.0141 2.20344 20.5602 2 20.0282 2H12.9859V3.97183H20.0282V11.0141H22V3.97183C22 3.43975 21.7966 2.98592 21.3897 2.61033Z",
    fill: "#878793"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3.97183 11.0141V3.97183H11.0141V2H3.97183C3.43975 2 2.97027 2.20344 2.56338 2.61033C2.18779 2.98592 2 3.43975 2 3.97183V11.0141H3.97183Z",
    fill: "#878793"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M17.9618 17.0235V18.0094H5.94302V17.0235C5.94302 16.1158 6.6316 15.3803 8.00875 14.8169C9.3859 14.2222 10.7005 13.9249 11.9524 13.9249C13.2044 13.9249 14.5189 14.2222 15.8961 14.8169C17.2732 15.3803 17.9618 16.1158 17.9618 17.0235Z",
    fill: "#878793"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9524 5.99061C12.7662 5.99061 13.4704 6.28795 14.0651 6.88263C14.6598 7.47731 14.9571 8.18153 14.9571 8.99531C14.9571 9.80908 14.6598 10.5133 14.0651 11.108C13.4704 11.7027 12.7662 12 11.9524 12C11.1386 12 10.4344 11.7027 9.83973 11.108C9.24505 10.5133 8.94771 9.80908 8.94771 8.99531C8.94771 8.18153 9.24505 7.47731 9.83973 6.88263C10.4344 6.28795 11.1386 5.99061 11.9524 5.99061Z",
    fill: "#878793"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconPersonInShot);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon-person-in-shot.22e2f7cf5dfc52dd3e957c8738645b9d.svg";